import Box, { BoxProps } from '@mui/material/Box';
import Button, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export const StyledButton = styled(Button)<ButtonProps>`
  position: relative;
  --btn-Color: ${({ theme }) => theme.vars.palette.primary.main};
  min-width: unset;
`;
export const LoadingIndicatorBox = styled(Box)<BoxProps>`
  position: absolute;
  z-index: 100;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.neutral['00']};
  border-radius: 8px;

  & polyline {
    stroke: var(--btn-Color);
  }
`;
